const en = {
  '济南文越环保工程有限公司': 'Jinan Wenyue Environmental Protection Engineering Co., LTD',
  '首页':'Home Page',
  '产品':'Product',
  '客户案列':'Customer case List',
  '公司介绍':'Company Introduction',
  '联系电话':'Contact Number',
  '联系邮箱':'Contact Email',
  '联系地址':'Contact Address',
  '了解更多':'Learn more',
  '京ICP备12025439号':'Beijing ICP Record No. 12025439',

  home:{
    '质量第一、客户为本':'Quality First, Customer-oriented',
    '保护生态环境·共创美好家园':'Protecting the Ecological Environment · Creating a Beautiful Homeland Together',
    '在职员工':'Current employee',
    '厂区占地面积':'Factory area',
    '查看更多':'View more',
    '联系我们':'Contact us',
    '人':'people',
    '千m²':'Thousand square meters',

  },

  login:{
    title:'I am the title',
  }
}
export default en;
